"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateUtils = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const isSameOrAfter_js_1 = __importDefault(require("dayjs/plugin/isSameOrAfter.js"));
const timezone_js_1 = __importDefault(require("dayjs/plugin/timezone.js"));
const utc_js_1 = __importDefault(require("dayjs/plugin/utc.js"));
dayjs_1.default.extend(utc_js_1.default);
dayjs_1.default.extend(timezone_js_1.default);
dayjs_1.default.extend(isSameOrAfter_js_1.default);
class DateUtils {
}
exports.DateUtils = DateUtils;
_a = DateUtils;
DateUtils.defaultLocale = 'fr-FR';
DateUtils.defaultTimezone = 'Europe/Paris';
DateUtils.format = (date, options) => {
    var _b, _c;
    if (!date)
        return '';
    const locale = (_b = options === null || options === void 0 ? void 0 : options.locale) !== null && _b !== void 0 ? _b : _a.defaultLocale;
    const timeZone = (_c = options === null || options === void 0 ? void 0 : options.timeZone) !== null && _c !== void 0 ? _c : _a.defaultTimezone;
    if (options === null || options === void 0 ? void 0 : options.hours) {
        return new Intl.DateTimeFormat(locale, {
            dateStyle: 'short',
            timeStyle: 'short',
            timeZone,
        }).format(date);
    }
    return new Intl.DateTimeFormat(locale, {
        dateStyle: 'short',
        timeZone,
    }).format(date);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZS51dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9kYXRlLXV0aWxzL2RhdGUudXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLGtEQUF5QjtBQUN6QixxRkFBeUQ7QUFDekQsMkVBQStDO0FBQy9DLGlFQUFxQztBQUVyQyxlQUFLLENBQUMsTUFBTSxDQUFDLGdCQUFHLENBQUMsQ0FBQTtBQUNqQixlQUFLLENBQUMsTUFBTSxDQUFDLHFCQUFRLENBQUMsQ0FBQTtBQUN0QixlQUFLLENBQUMsTUFBTSxDQUFDLDBCQUFhLENBQUMsQ0FBQTtBQVEzQixNQUFhLFNBQVM7O0FBQXRCLDhCQXVCQzs7QUF0QnlCLHVCQUFhLEdBQUcsT0FBTyxBQUFWLENBQVU7QUFDdkIseUJBQWUsR0FBRyxjQUFjLEFBQWpCLENBQWlCO0FBRWpELGdCQUFNLEdBQUcsQ0FBQyxJQUFXLEVBQUUsT0FBMEIsRUFBVSxFQUFFOztJQUNsRSxJQUFJLENBQUMsSUFBSTtRQUFFLE9BQU8sRUFBRSxDQUFBO0lBRXBCLE1BQU0sTUFBTSxHQUFHLE1BQUEsT0FBTyxhQUFQLE9BQU8sdUJBQVAsT0FBTyxDQUFFLE1BQU0sbUNBQUksRUFBSSxDQUFDLGFBQWEsQ0FBQTtJQUNwRCxNQUFNLFFBQVEsR0FBRyxNQUFBLE9BQU8sYUFBUCxPQUFPLHVCQUFQLE9BQU8sQ0FBRSxRQUFRLG1DQUFJLEVBQUksQ0FBQyxlQUFlLENBQUE7SUFFMUQsSUFBSSxPQUFPLGFBQVAsT0FBTyx1QkFBUCxPQUFPLENBQUUsS0FBSyxFQUFFLENBQUM7UUFDbkIsT0FBTyxJQUFJLElBQUksQ0FBQyxjQUFjLENBQUMsTUFBTSxFQUFFO1lBQ3JDLFNBQVMsRUFBRSxPQUFPO1lBQ2xCLFNBQVMsRUFBRSxPQUFPO1lBQ2xCLFFBQVE7U0FDVCxDQUFDLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQ2pCLENBQUM7SUFFRCxPQUFPLElBQUksSUFBSSxDQUFDLGNBQWMsQ0FBQyxNQUFNLEVBQUU7UUFDckMsU0FBUyxFQUFFLE9BQU87UUFDbEIsUUFBUTtLQUNULENBQUMsQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUE7QUFDakIsQ0FBQyxBQWxCWSxDQWtCWiJ9